import { useApiClient } from '@/api/client.js'
import { type CheckInModePinCode, ValidatePinResponseSchema } from '../types.ts'

import { decamelizeKeys } from '@/functions/utils/index.js'

export const VALIDATE_PIN_CODE = '/core/v2/business_api/me/businesses/{businessId}/turntracker/pin/validate'

export const validatePinCode = (options: {
  businessId: number;
  payload: CheckInModePinCode;
}) => {
  const apiClient = useApiClient()

  return apiClient.post({
    url: VALIDATE_PIN_CODE,
    urlParams: {
      businessId: options.businessId,
    },
    data: decamelizeKeys(options.payload),
  })
    .then(({ data }) => ValidatePinResponseSchema.parse(data))
}
